



import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

import Assets from '@/constants/assets.ts';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import Btn, { BtnColor, BtnWidth } from '@/shared/components/btn.component.vue';
import TopModal from '@/shared/components/TopModal.component.vue';
import TextArea from '@/shared/components/text-area.component.vue';
import NoteItem from '@/manager/convocation/views/convocationDetail/noteItem/noteItem.view.vue';
import { Note } from '@/manager/convocation/note.model';
import UtilsService from '@/core/services/utils.service';

@Component({
    components: {
        Icon,
        Btn,
        TopModal,
        TextArea,
        NoteItem,
    },
    computed: {
        ...mapGetters ({
            getProfile: 'getProfile',
            convocationNoteList: 'getConvocationNotes',
        }),
    },
})
export default class AddNoteModal extends Vue {
    @Prop() private opened!: boolean;
    @Prop() private convocationId!: string;

    private assets = Assets;
    private iconEnum = IconEnum;
    private btnColor = BtnColor;
    private btnWidth = BtnWidth;
    private utilsService = UtilsService;
    private convocationNoteList!: Note[];
    private newNoteText = '';
    private newNoteTextEmpty = false;
    private getProfile!: any;

    @Watch('opened')
    private watchOpened(newVal: boolean, oldVal: boolean) {
        if ( newVal ) {
            this.fetchConvocationNotes();
        }
    }

    get profileAvatar() {
        let avatar = this.assets.defaultAvatar;
        if (
            this.getProfile.profile &&
            this.getProfile.profile.avatar !== null
        ) {
            avatar = this.getProfile.profile.avatar;
        }
        return avatar;
    }

    get newPlaceholder() {
        let placeholder = 'Comparte alguna nota con tus compañeros sobre esta convocatoria...';
        if ( this.newNoteTextEmpty ) {
            placeholder = 'Este campo no puede estar vacío...';
        }
        return placeholder;
    }

    get areThereNotes() {
        return this.convocationNoteList.length > 0;
    }

    private fetchConvocationNotes() {
        this.$store.dispatch(
            'fetchConvocationNotes',
            {
                convocationId: this.convocationId,
            },
        ).then((res: any) => {
            const parentNode = ( this.$el.parentNode as HTMLElement );
            if ( parentNode ) {
                parentNode.scrollTop = parentNode.scrollHeight;
            }
        });
    }

    private addNote() {
        if ( this.newNoteText.length === 0 ) {
            this.newNoteTextEmpty = true;
        } else {
            this.$store.dispatch(
                'newConvocationNote',
                {
                    convocationId: this.convocationId,
                    note: this.newNoteText,
                },
            ).then((res) => {
                this.resetNewNoteTextEmpty( true );
            });
        }
    }

    private refreshNotes() {
        this.fetchConvocationNotes();
        this.resetNewNoteTextEmpty( true );
    }

    private updateNote( noteId: string, noteContent: string, isPostponement?: string, mentions?: any[] ) {
        // console.log(mentions);
        const payload = {
            convocationId: this.convocationId,
            noteId,
            data: { note: noteContent, employeeModified: this.getProfile.id, isPostponement: isPostponement, mentions: mentions },
        };
        this.$store.dispatch('patchConvocationNote', payload);
    }

    private deleteNote( noteId: string ) {
        const payload = {
            convocationId: this.convocationId,
            noteId,
        };
        this.$store.dispatch('removeConvocationNote', payload);
    }

    private resetNewNoteTextEmpty( force: boolean ) {
        if ( force || this.newNoteText === '' ) {
            this.newNoteTextEmpty = false;
            this.newNoteText = '';
        }
    }

    private closeModal() {
        if ( this.opened ) {
            this.$emit('close-modal-add-note', false);
        }
    }

}
